export const PathDefinition = {
    home: '/',
    track: '/track'
};
